
const topTrechosExpressojk = [
    {
        idCidadeOrigem: 1,
        nomeCidadeOrigemComUF: 'Brasília-DF',
        nomeCidadeOrigemComUFNormalizado: 'brasilia-df',
        idCidadeDestino: 5848,
        nomeCidadeDestinoComUF: 'São Paulo-SP',
        nomeCidadeDestinoComUFNormalizado: 'saopaulo-sp',
        ordem: 1
    },
    {
        idCidadeOrigem: 5473,
        nomeCidadeOrigemComUF: 'Franca-SP',
        nomeCidadeOrigemComUFNormalizado: 'franca-sp',
        idCidadeDestino: 126,
        nomeCidadeDestinoComUF: 'Goiânia-GO',
        nomeCidadeDestinoComUFNormalizado: 'goiania-go',
        ordem: 2
    },
    {
        idCidadeOrigem: 3255,
        nomeCidadeOrigemComUF: 'Uberaba-MG',
        nomeCidadeOrigemComUFNormalizado: 'uberaba-mg',
        idCidadeDestino: 1,
        nomeCidadeDestinoComUF: 'Brasília-DF',
        nomeCidadeDestinoComUFNormalizado: 'brasilia-df',
        ordem: 3
    },
    {
        idCidadeOrigem: 126,
        nomeCidadeOrigemComUF: 'Goiânia-GO',
        nomeCidadeOrigemComUFNormalizado: 'goiania-go',
        idCidadeDestino: 5473,
        nomeCidadeDestinoComUF: 'Franca-SP',
        nomeCidadeDestinoComUFNormalizado: 'franca-sp',
        ordem: 4
    },
    {
        idCidadeOrigem: 1,
        nomeCidadeOrigemComUF: 'Brasília-DF',
        nomeCidadeOrigemComUFNormalizado: 'brasilia-df',
        idCidadeDestino: 7450,
        nomeCidadeDestinoComUF: 'Campinas Posto Garcia-SP',
        nomeCidadeDestinoComUFNormalizado: 'campinaspostogarcia-quintadomarques-sp',
        ordem: 5
    },
    {
        idCidadeOrigem: 126,
        nomeCidadeOrigemComUF: 'Goiânia-GO',
        nomeCidadeOrigemComUFNormalizado: 'goiania-go',
        idCidadeDestino: 5848,
        nomeCidadeDestinoComUF: 'São Paulo-SP',
        nomeCidadeDestinoComUFNormalizado: 'saopaulo-sp',
        ordem: 6
    },
    {
        idCidadeOrigem: 5848,
        nomeCidadeOrigemComUF: 'São Paulo-SP',
        nomeCidadeOrigemComUFNormalizado: 'saopaulo-sp',
        idCidadeDestino: 126,
        nomeCidadeDestinoComUF: 'Goiânia-GO',
        nomeCidadeDestinoComUFNormalizado: 'goiania-go',
        ordem: 7
    },
    {
        idCidadeOrigem: 5848,
        nomeCidadeOrigemComUF: 'São Paulo-SP',
        nomeCidadeOrigemComUFNormalizado: 'saopaulo-sp',
        idCidadeDestino: 1,
        nomeCidadeDestinoComUF: 'Brasília-DF',
        nomeCidadeDestinoComUFNormalizado: 'brasilia-df',
        ordem: 8
    },
    {
        idCidadeOrigem: 1,
        nomeCidadeOrigemComUF: 'Brasília-DF',
        nomeCidadeOrigemComUFNormalizado: 'brasilia-df',
        idCidadeDestino: 3255,
        nomeCidadeDestinoComUF: 'Uberaba-MG',
        nomeCidadeDestinoComUFNormalizado: 'uberaba-mg',
        ordem: 9
    },
    {
        idCidadeOrigem: 7450,
        nomeCidadeOrigemComUF: 'Campinas Posto Garcia-SP',
        nomeCidadeOrigemComUFNormalizado: 'campinaspostogarcia-quintadomarques-sp',
        idCidadeDestino: 126,
        nomeCidadeDestinoComUF: 'Goiânia-GO',
        nomeCidadeDestinoComUFNormalizado: 'goiania-go',
        ordem: 10
    },
    {
        idCidadeOrigem: 5848,
        nomeCidadeOrigemComUF: 'São Paulo-SP',
        nomeCidadeOrigemComUFNormalizado: 'saopaulo-sp',
        idCidadeDestino: 47,
        nomeCidadeDestinoComUF: 'Anápolis-GO',
        nomeCidadeDestinoComUFNormalizado: 'anapolis-go',
        ordem: 11
    },
    {
        idCidadeOrigem: 1,
        nomeCidadeOrigemComUF: 'Brasília-DF',
        nomeCidadeOrigemComUFNormalizado: 'brasilia-df',
        idCidadeDestino: 3256,
        nomeCidadeDestinoComUF: 'Uberlândia-MG',
        nomeCidadeDestinoComUFNormalizado: 'uberlandia-mg',
        ordem: 12
    },
    {
        idCidadeOrigem: 3256,
        nomeCidadeOrigemComUF: 'Uberlândia-MG',
        nomeCidadeOrigemComUFNormalizado: 'uberlandia-mg',
        idCidadeDestino: 1,
        nomeCidadeDestinoComUF: 'Brasília-DF',
        nomeCidadeDestinoComUFNormalizado: 'brasilia-df',
        ordem: 13
    },
    {
        idCidadeOrigem: 47,
        nomeCidadeOrigemComUF: 'Anápolis-GO',
        nomeCidadeOrigemComUFNormalizado: 'anapolis-go',
        idCidadeDestino: 5500,
        nomeCidadeDestinoComUF: 'Guarulhos-SP',
        nomeCidadeDestinoComUFNormalizado: 'guarulhos-sp',
        ordem: 14
    },
    {
        idCidadeOrigem: 47,
        nomeCidadeOrigemComUF: 'Anápolis-GO',
        nomeCidadeOrigemComUFNormalizado: 'anapolis-go',
        idCidadeDestino: 7450,
        nomeCidadeDestinoComUF: 'Campinas Posto Garcia-SP',
        nomeCidadeDestinoComUFNormalizado: 'campinaspostogarcia-quintadomarques-sp',
        ordem: 15
    }

];



export default topTrechosExpressojk;